import useShowDialogAlert from "components/DialogAlert/utils/hooks/useDialogAlert";
import { useState } from "react";
import { SPACE_RESERVATION_ERRORS } from "../../../utils/constants";

export const DESCRIPTIONS = Object.freeze({
	[SPACE_RESERVATION_ERRORS.STUDENTS_WITH_ACTIVE_PENALTY]: "Algunos alumnos cuentan con una sanción vigente:",
	[SPACE_RESERVATION_ERRORS.STUDENTS_WITH_HOURS_LIMIT_REACHED]: "Algunos alumnos han alcanzado o están excediendo el límite de horas diarias:",
	[SPACE_RESERVATION_ERRORS.STUDENTS_WITH_SCHEDULE_CROSSING]: "Algunos alumnos  tienen otra reserva en el mismo horario:"
});

const useDialogAddStudentError = () => {
	const dialog = useShowDialogAlert();
	const [description, setDescription] = useState("");
	const [studentsWithErrors, setStudentsWithErrors] = useState([]);
	function open({ message, studentsWithErrors }) {
		const newDescription = DESCRIPTIONS[message];
		if (!newDescription) return false;
		setDescription(newDescription);
		setStudentsWithErrors(studentsWithErrors);
		dialog.open();
		return true;
	}
	return {
		...dialog,
		open, description, studentsWithErrors
	};
}

export default useDialogAddStudentError;